export default __webpack_public_path__ + "aa9b787563f69db9b3f0dcdda2f8bf78.svg";